module.exports = __webpack_public_path__ + "img/logo.eec5675f.png";